/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // ---- Custom Size Toggle ----
  function initCustomSizeToggle() {
    var customSizeInput = document.querySelector('input[name*="Custom Size"]');
    if (!customSizeInput) return;

    var sizeRadios = document.querySelectorAll('input[data-single-option-selector]');
    if (!sizeRadios.length) return;

    function toggleCustomSizeField() {
      var selectedRadio = document.querySelector('input[data-single-option-selector]:checked');
      if (selectedRadio && selectedRadio.value.toLowerCase() === 'custom') {
        customSizeInput.disabled = false;
        customSizeInput.closest('.product__block').style.opacity = '1';
        customSizeInput.closest('.product__block').style.pointerEvents = 'auto';
      } else {
        customSizeInput.disabled = true;
        customSizeInput.value = '';
        customSizeInput.closest('.product__block').style.opacity = '0.4';
        customSizeInput.closest('.product__block').style.pointerEvents = 'none';
      }
    }

    sizeRadios.forEach(function(radio) {
      radio.addEventListener('change', toggleCustomSizeField);
    });

    toggleCustomSizeField();
  }

  // Delay to ensure page is fully rendered
  setTimeout(initCustomSizeToggle, 1000);
  // ---- End Custom Size Toggle ----



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
